import { render } from "./UserEditPage.vue?vue&type=template&id=50cbb06a"
import script from "./UserEditPage.vue?vue&type=script&lang=js"
export * from "./UserEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__